<template>
  <div id="app">
    <!-- <div class="head_bar">
      <dy-header :title="title"
        :back="title !== '首页'"
        :rightText="userName"></dy-header>
    </div> -->
    <transition :name="transitionName">
      <keep-alive :include="includeKeepPage.toString()">
        <router-view class="child-view"> </router-view>
      </keep-alive>

      <!-- <keep-alive v-if="$route.meta.keepAlive ">
        <router-view class="child-view d"></router-view>
      </keep-alive>
      <router-view class="child-view"
        v-if="!$route.meta.keepAlive"></router-view> -->
    </transition>
    <div class="loadding-back"
      v-if="global.showLoading">
      <van-loading class="loadding"
        color="#fff"
        type="spinner"
        vertical="true" />
    </div>
  </div>
</template>

<script>
import DyHeader from './components/DyHeader'
import Global from '../src/assets/js/globalData'
export default {
  name: 'App',
  components: {
    DyHeader
  },
  data() {
    // 变量定义
    return {
      title: this.$route.meta.title,
      transitionName: 'zoom-in',
      code: null,
      userName: '',
      codeB: false,
      global: Global,
      includeKeepPage: ['recharge', 'pay-add', 'phoneList']
    }
  },
  methods: {
    // 设置html字体大小
    initialHtmlFontSize() {
      let deviceWidth =
        window.innerWidth ||
        document.body.clientWidth ||
        document.documentElement.clientWidth
      // 以iphone6屏幕尺寸为标准 ( 1rem = 100px )
      let maxWidth = deviceWidth >= 640 ? 640 : deviceWidth
      document.getElementsByTagName('html')[0].style.fontSize =
        maxWidth / 3.75 + 'px'
    }
  },
  watch: {
    $route(to, from) {
      this.title = this.$route.meta.title
      if (to.path === '/') {
        this.transitionName = 'slide-right'
      } else {
        this.transitionName = 'slide-left'
      }
    }
  },
  created() {
    this.initialHtmlFontSize()
    window.addEventListener('resize', this.initialHtmlFontSize)
    console.log(11, this.includeKeepPage.toString())
  }
}
</script>

<style lang="less">
/* 引入公共样式 */
@import '~@/assets/style/common';
.loadding-back {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  padding: 30px 40px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/App.vue